/// Where a notification's "View" link should take the reader.
///
/// A pure function, and deliberately not inlined in the notifications route:
/// every case here encodes a routing constraint that is easy to get subtly
/// wrong and invisible when it is (the link still works, it just lands
/// somewhere useless), so each one is pinned by a test.
export type NotificationLinkInput = {
	type?: string | null;
	resourceType?: string | null;
	resourceId?: string | null;
};

export function deepLinkFor(n: NotificationLinkInput): string | null {
	// Store notifications must land in the STORE app, not the admin order page:
	// a store user has no access to /orders and would be bounced to the
	// dashboard, losing the link entirely.
	if (n.type === "store_order_offered") return "/store/orders";
	if (n.type === "store_order_lost") return "/store/orders?tab=lost";
	// store_order_unassigned goes to admins, who do have the order page.
	if (n.type === "store_order_unassigned" && n.resourceId) {
		return `/orders/${n.resourceId}`;
	}
	if (n.resourceType === "farfetch_order" && n.resourceId) {
		return `/orders/${n.resourceId}`;
	}
	if (n.resourceType === "farfetch_ingest_report") {
		// The report lives on the Exports tab, and `resourceId` names WHICH
		// report. Without both params this landed on the page's default tab
		// (Credentials), so the operator had to know to click through to Exports
		// and find the report by hand - reported 2026-08-31, on the day the
		// ingest-result poller was first enabled and fanned out 37 of these.
		return n.resourceId
			? `/integrations/farfetch?tab=export&report=${n.resourceId}`
			: "/integrations/farfetch?tab=export";
	}
	if (n.resourceType === "farfetch_price_report") {
		// Same constraint as the ingest report: name the tab AND the report, or
		// the operator lands on Credentials with nothing expanded.
		return n.resourceId
			? `/integrations/farfetch?tab=export&priceReport=${n.resourceId}`
			: "/integrations/farfetch?tab=export";
	}
	return null;
}
